import { AspectRatio, Box, Grid, GridItem, VStack } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useSettingsContext } from "../../../contexts/SettingsContext";
import CallToLoginView from "./CallToLoginView";
import { Checkmark } from "../../../components/APAssetAtlas";
import APButton from "../../../components/APButton";

interface WallpapersInterface {
  setBackground: Function;
  background: number | string;
  isLoggedIn: boolean;
  sdk: any;
}

interface SkinInterface {
  id: string,
  data: {
    background: string,
    thumbnail: string,
    color: { iv: string },
    name: { iv: string }
  }
}

function WallpapersView(props: WallpapersInterface) {
  const { setBackground, background, isLoggedIn, sdk } = props;
  const { setSkin } = useSettingsContext();

  const [data, setData] = useState<SkinInterface[]>(() => {
    return [...Array(4)].map((_, index) => ({
      id: `locked_${index}`,
      data: {
        background: "",
        thumbnail: "wallpapers/Locked.png",
        color: { iv: "#f5f3ef" },
        name: { iv: "Locked" }
      }
    } as SkinInterface))
  })
    ;

  useEffect(() => {
    const fetchSkins = async () => {
      const skins = await sdk.getDataManager().getSkins();
      setData(skins && Array.isArray(skins) ? skins : []);
    }
    isLoggedIn && fetchSkins();
  }, [sdk, isLoggedIn]);

  const onSelectBg = (id: number | string) => {
    sdk.getAnalytics().push({ action: "change", event: "skin", id: id, platform: process.env.REACT_APP_PLATFORM });
    setBackground(id);
  };

  const formatUrl = (target: string) => {
    if (target.startsWith("http")) {
      return target;
    } else {
      return `${process.env.REACT_APP_BASE_URL}/${target}`
    }
  }

  return (
    <VStack alignItems={"stretch"} gap={2}>
      <Grid display={"grid"} gridTemplateColumns="repeat(2, 1fr)" gridGap={2} p={0} justifyItems={"stretch"}
        alignItems={"stretch"}>
        {data.map((item) => (
          <GridItem key={item.id}>
            <AspectRatio ratio={1.55} maxWidth={"100%"}>
              <APButton position={"relative"} width={"100%"} height={"auto"}
                variant={"solid"} padding={"0px !important"} overflow={"visible !important"}
                disabled={item.id.startsWith("locked")}
                onClick={() => {
                  onSelectBg(item.id)
                  setSkin(item)
                }}
                rounded={"xl"}
                bg={item.data?.color?.iv}
                bgSize={item.id.startsWith("locked") ? "contain" : "cover"}
                bgImage={formatUrl(item.data?.thumbnail)}
                bgRepeat={"no-repeat"} bgPosition={"center"}
                border={"3px solid"}
                borderColor={item.id === background ? "#FFCD35" : item.data?.color?.iv}
                _hover={{ boxShadow: `0 0 0 3px ${item.data?.color?.iv}` }}
                _focus={{ boxShadow: `0 0 0 3px ${item.data?.color?.iv}` }}
                _active={{}}
                _disabled={{ pointerEvents: "none" }}>
                <Box
                  hidden={item.id !== background}
                  borderRadius={"0.5rem 0 0.25rem 0"}
                  bg={"#FFCD35"}
                  width={["1.5rem", "2rem"]}
                  height={["1.5rem", "2rem"]}
                  display={"flex"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  bottom={0}
                  right={0}
                  position={"absolute"}>
                  <Checkmark />
                </Box>
              </APButton>
            </AspectRatio>
          </GridItem>
        ))}
      </Grid>
      {!isLoggedIn && <CallToLoginView />}
    </VStack>

  );
}

export default WallpapersView;
